// extracted by mini-css-extract-plugin
module.exports = {"Link":"CaseListItem_Link__25jPs","button":"CaseListItem_button__JaGjJ"};